<template>
  <div class="flex flex-column w-full h-full">
    <div v-if="(!loaded)"><AppSpinner /></div>
    <div v-if="(loaded)" class="flex flex-column w-full h-full">
      <div class="flex flex-column w-full h-full">
        <div class="flex w-full font-bold text-lg text-white appColor-01-bg border-round-top-xl px-3 py-2">
          <div class="flex flex-grow-1" v-html="botClient.botNome"></div>
          <div class="flex"><AppLang /></div>
        </div>
        <div class="flex w-full font-semibold text-xs text-white appColor-02-bg appColor-02-border border-2 border-solid px-3 py-1" v-html="botClient.botNomeEmpresa"></div>
        <div class="flex w-full appGray-01-bg">
          <div class="shape-divider">
            <div class="shape-divider-top">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="flex w-full flex-grow-1 justify-content-center appGray-01-bg">
          <div class="bot-content w-full overflow-y-auto">
            <div v-if="(!loaded)"><AppSpinner /></div>
            <div v-if="(loaded)" class="flex flex-column w-full justify-content-center p-3">
              <div class="flex flex-column w-full justify-content-center gap-3">
                <component v-for="(forItem, forIndex) in list" :key="forIndex" v-bind:is="forItem.component" :name="forItem.component" />
              </div>
              <div ref="botBottom" class="flex flex-column w-full justify-content-center"></div>
            </div>
          </div>
        </div>
        <div class="flex w-full appGray-01-bg">
          <div class="shape-divider">
            <div class="shape-divider-bottom">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="flex w-full font-bold appGray-02-bg border-round-bottom-xl">
          <div class="flex w-full align-items-center gap-3 p-3" style="height:70px;">
            <div class="flex align-items-center">
              <Button @click="mt_restart()" icon="pi pi-refresh text-2xl" v-tooltip.top="{ value: $store.state.txt_app.bt_recomecar, escape: false }" class="app-button" text rounded raised />
            </div>
            <div v-if="(form.insert && form.insertField != '')" class="flex flex-grow-1">
              <InputText v-if="(form.insertField == 'novaDenuncia_nome')" id="novaDenuncia_nome" v-model="novaDenuncia_nome.txt" :placeholder="$store.state.txt_app.field_nome" :class="'w-full' + (v$.novaDenuncia_nome.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <InputText v-if="(form.insertField == 'novaDenuncia_empresa')" id="novaDenuncia_empresa" v-model="novaDenuncia_empresa.txt" :placeholder="$store.state.txt_app.field_empresa" :class="'w-full' + (v$.novaDenuncia_empresa.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <InputText v-if="(form.insertField == 'novaDenuncia_email')" id="novaDenuncia_email" v-model="novaDenuncia_email.txt" :placeholder="$store.state.txt_app.field_email" :class="'w-full' + (v$.novaDenuncia_email.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <InputText v-if="(form.insertField == 'novaDenuncia_setorAreaOutro')" id="novaDenuncia_setorAreaOutro" v-model="novaDenuncia_setorAreaOutro.txt" :placeholder="$store.state.txt_app.field_setorAreaOutro" :class="'w-full' + (v$.novaDenuncia_setorAreaOutro.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <InputText v-if="(form.insertField == 'novaDenuncia_denuncia')" id="novaDenuncia_denuncia" v-model="novaDenuncia_denuncia.txt" :placeholder="$store.state.txt_app.field_denuncia" :class="'w-full' + (v$.novaDenuncia_denuncia.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <InputText v-if="(form.insertField == 'novaDenuncia_denunciaMais')" id="novaDenuncia_denunciaMais" v-model="novaDenuncia_denunciaMais.txt" :placeholder="$store.state.txt_app.field_denunciaMais" :class="'w-full' + (v$.novaDenuncia_denunciaMais.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <FileUpload v-if="(form.insertField == 'novaDenuncia_files')" mode="basic" customUpload accept="image/jpeg,application/pdf" :multiple="true" :auto="true" @uploader="mt_onFileSelect($event)" class="w-full app-button" />
              <InputText v-if="(form.insertField == 'novaDenuncia_emailHistorico')" id="novaDenuncia_emailHistorico" v-model="novaDenuncia_emailHistorico.txt" :placeholder="$store.state.txt_app.field_emailHistorico" :class="'w-full' + (v$.novaDenuncia_emailHistorico.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <InputText v-if="(form.insertField == 'novaVerificacao_referencia')" id="novaVerificacao_referencia" v-model="novaVerificacao_referencia.txt" :placeholder="$store.state.txt_app.field_referencia" :class="'w-full' + (v$.novaVerificacao_referencia.txt.$errors.length ? ' p-invalid' : '')" size="small" />
              <InputMask v-if="(form.insertField == 'novaVerificacao_data')" id="novaVerificacao_data" v-model="novaVerificacao_data.txt" :placeholder="$store.state.txt_app.field_dataDaDenuncia" :class="'w-full p-inputtext-sm' + (v$.novaVerificacao_data.txt.$errors.length ? ' p-invalid' : '')" mask="99-99-9999" />
              <Password v-if="(form.insertField == 'novaVerificacao_password')" inputId="novaVerificacao_password" v-model="novaVerificacao_password.txt" :placeholder="$store.state.txt_app.field_password" class="w-full" :inputClass="'w-full p-inputtext-sm' + (v$.novaVerificacao_password.txt.$errors.length ? ' p-invalid' : '')" :feedback="false" />
            </div>
            <div v-if="(form.insert && form.insertField != '' && form.insertField != 'novaDenuncia_files')" class="flex align-items-center">
              <Button @click="mt_formSend()" icon="pi pi-arrow-up text-xl" v-tooltip.top="{ value: $store.state.txt_app.bt_enviar, escape: false }" class="app-button" rounded raised />
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column w-full justify-content-center mt-2">
        <a class="flex justify-content-center text-xs link" :href="botClient.botPoweredByUrl" target="_blank" v-html="$store.state.txt_app.bt_poweredBy + '&nbsp;' + '<b>' + botClient.botPoweredBy + '</b>'"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { helpers, required, email, maxLength } from '@vuelidate/validators';
import AppLang from '@/components/AppLang.vue';
import Ecra01 from '@/components/Ecra01.vue';
import Ecra02 from '@/components/Ecra02.vue';
import Ecra03 from '@/components/Ecra03.vue';
import Ecra04 from '@/components/Ecra04.vue';
import Ecra05 from '@/components/Ecra05.vue';
import Ecra06 from '@/components/Ecra06.vue';
import Ecra07 from '@/components/Ecra07.vue';
import Ecra08 from '@/components/Ecra08.vue';
import Ecra09 from '@/components/Ecra09.vue';
import Ecra10 from '@/components/Ecra10.vue';
import Ecra11 from '@/components/Ecra11.vue';
import Ecra12 from '@/components/Ecra12.vue';
import Ecra13 from '@/components/Ecra13.vue';
import Ecra14 from '@/components/Ecra14.vue';
import Ecra15 from '@/components/Ecra15.vue';
import Ecra16 from '@/components/Ecra16.vue';
import Ecra17 from '@/components/Ecra17.vue';
import Ecra18 from '@/components/Ecra18.vue';
import Ecra19 from '@/components/Ecra19.vue';
import Ecra20 from '@/components/Ecra20.vue';
import Ecra21 from '@/components/Ecra21.vue';
import Ecra22 from '@/components/Ecra22.vue';
import Ecra23 from '@/components/Ecra23.vue';
import Ecra24 from '@/components/Ecra24.vue';
import Ecra25 from '@/components/Ecra25.vue';
export default {
  setup () { return { v$: useVuelidate() }; },
  components: {
    AppLang,
    Ecra01, Ecra02, Ecra03, Ecra04, Ecra05,
    Ecra06, Ecra07, Ecra08, Ecra09, Ecra10,
    Ecra11, Ecra12, Ecra13, Ecra14, Ecra15,
    Ecra16, Ecra17, Ecra18, Ecra19, Ecra20,
    Ecra21, Ecra22, Ecra23, Ecra24, Ecra25,
  },
  data() {
    return {
      loaded: false,
      botAddress: null,
      botClient: null,
      list: [],
      form: {
        insert: false, insertField: '',
        novaDenuncia: {
          anonimo: true,
          nome: null, empresa: null, email: null,
          setor: null, setorArea: null, setorAreaOutro: null,
          denuncia: null, denunciaMais: null,
          files: null,
          emailHistorico: null,
        },
        novaVerificacao: {
          referencia: null, password: null, data: null,
        },
      },
      novaDenuncia_nome: { txt: null },
      novaDenuncia_empresa: { txt: null },
      novaDenuncia_email: { txt: null },
      novaDenuncia_setorAreaOutro: { txt: null },
      novaDenuncia_denuncia: { txt: null },
      novaDenuncia_denunciaMais: { txt: null },
      novaDenuncia_files: { txt: null, errors: null },
      novaDenuncia_emailHistorico: { txt: null },
      novaVerificacao_referencia: { txt: null },
      novaVerificacao_data: { txt: null },
      novaVerificacao_password: { txt: null },
      novaDenuncia_response: { referencia: '', password: '', data: '' },
      novaVerificacao_response: { referencia: '', porData: false, porPassword: false, estadoTxt: '', observacoes: '' },
    };
  },
  validations () {
    return {
      novaDenuncia_nome: {
        txt: {
          required: helpers.withMessage(this.$store.state.txt_app.field_required, required),
          maxLength: helpers.withMessage(this.$store.state.txt_app.field_maxLength_100, maxLength(100)),
        },
      },
      novaDenuncia_empresa: {
        txt: {
          maxLength: helpers.withMessage(this.$store.state.txt_app.field_maxLength_100, maxLength(100)),
        },
      },
      novaDenuncia_email: {
        txt: {
          required: helpers.withMessage(this.$store.state.txt_app.field_required, required),
          email: helpers.withMessage(this.$store.state.txt_app.field_invalid, email),
        },
      },
      novaDenuncia_setorAreaOutro: {
        txt: {
          required: helpers.withMessage(this.$store.state.txt_app.field_required, required),
          maxLength: helpers.withMessage(this.$store.state.txt_app.field_maxLength_100, maxLength(100)),
        },
      },
      novaDenuncia_denuncia: {
        txt: {
          required: helpers.withMessage(this.$store.state.txt_app.field_required, required),
        },
      },
      novaDenuncia_denunciaMais: {
        txt: {},
      },
      novaDenuncia_emailHistorico: {
        txt: {
          email: helpers.withMessage(this.$store.state.txt_app.field_invalid, email),
        },
      },
      novaVerificacao_referencia: {
        txt: {
          required: helpers.withMessage(this.$store.state.txt_app.field_required, required),
          maxLength: helpers.withMessage(this.$store.state.txt_app.field_maxLength_20, maxLength(20)),
        },
      },
      novaVerificacao_data: {
        txt: {
          required: helpers.withMessage(this.$store.state.txt_app.field_required, required),
          maxLength: helpers.withMessage(this.$store.state.txt_app.field_maxLength_10, maxLength(10)),
        },
      },
      novaVerificacao_password: {
        txt: {
          required: helpers.withMessage(this.$store.state.txt_app.field_required, required),
          maxLength: helpers.withMessage(this.$store.state.txt_app.field_maxLength_20, maxLength(20)),
        },
      },
    }
  },
  props: {},
  computed: {},
  watch: {
    '$route.params'(val) {
      if (this.$route.name == 'bot') {
        this.botAddress = null;
        this.botClient = null;
        this.list.splice(0, this.list.length);
        this.mt_formReset();
        this.mt_start();
      }
    },
  },
  methods: {
    mt_start() {
      this.botAddress = this.$route.params.botAddress;
      if (this.botAddress == null) { this.fc_goRoute('error'); }
      else { this.mt_getData(); }
    },
    mt_getData() {
      let promises = [];
      promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ParamSetores/', method: 'GET', success: (response) => { this.$store.state.param.setores = response.list; resolve(); }, error: reject }); }));
      promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ParamSetoresAreas/', method: 'GET', success: (response) => { this.$store.state.param.setoresAreas = response.list; resolve(); }, error: reject }); }));
      promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ParamSetoresAreasDef/', method: 'GET', success: (response) => { this.$store.state.param.setoresAreasDef = response.list; resolve(); }, error: reject }); }));
      promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'Clientes/' + this.botAddress + '/', method: 'GET', success: (response) => { this.botClient = response.item; resolve(); }, error: reject }); }));
      Promise.all(promises).then(() => { this.mt_getData_success(); }).catch((e) => { this.fc_printErrors(e); this.fc_goRoute('error'); });
    },
    mt_getData_success() {
      document.documentElement.style.setProperty('--appColor-01', this.botClient.botCor01);
      document.documentElement.style.setProperty('--appColor-02', this.botClient.botCor02);
      this.mt_first();
      this.loaded = true;
    },
    mt_first() {
      let ecra = { component: 'Ecra01' };
      this.list.push(ecra);
    },
    mt_restart() {
      this.mt_formReset();
      this.list.splice(0, this.list.length);
      setTimeout(() => {
        this.mt_first();
      }, 200);
    },
    mt_goBottom() {
      setTimeout(() => {
        const element = this.$refs.botBottom;
        element.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    },
    mt_formReset() {
      this.form.insert = false;
      this.form.insertField = '';

      this.form.novaDenuncia.anonimo = true;

      this.form.novaDenuncia.nome = null;
      this.form.novaDenuncia.empresa = null;
      this.form.novaDenuncia.email = null;

      this.form.novaDenuncia.setor = null;
      this.form.novaDenuncia.setorArea = null;
      this.form.novaDenuncia.setorAreaOutro = null;

      this.form.novaDenuncia.denuncia = null;
      this.form.novaDenuncia.denunciaMais = null;
      this.form.novaDenuncia.files = null;
      this.form.novaDenuncia.emailHistorico = null;

      this.novaDenuncia_nome.txt = null;
      this.novaDenuncia_empresa.txt = null;
      this.novaDenuncia_email.txt = null;

      this.novaDenuncia_setorAreaOutro.txt = null;

      this.novaDenuncia_denuncia.txt = null;
      this.novaDenuncia_denunciaMais.txt = null;

      this.novaDenuncia_files.txt = null;
      this.novaDenuncia_files.errors = null;

      this.novaDenuncia_emailHistorico.txt = null;

      this.novaDenuncia_response.referencia = '';
      this.novaDenuncia_response.password = '';
      this.novaDenuncia_response.data = '';

      this.form.novaVerificacao.referencia = null;
      this.form.novaVerificacao.data = null;
      this.form.novaVerificacao.password = null;

      this.novaVerificacao_referencia.txt = null;
      this.novaVerificacao_data.txt = null;
      this.novaVerificacao_password.txt = null;

      this.novaVerificacao_response.referencia = '';
      this.novaVerificacao_response.porData = false;
      this.novaVerificacao_response.porPassword = false;
      this.novaVerificacao_response.estadoTxt = '';
      this.novaVerificacao_response.observacoes = '';
    },
    mt_link(link) {
      window.open(link, '_blank');
    },
    async mt_formSend() {
      if (this.form.insertField == 'novaDenuncia_nome') {
        const valid = await this.v$.novaDenuncia_nome.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaDenuncia_nome.txt == null) { this.novaDenuncia_nome.txt = ''; }
          this.form.novaDenuncia.nome = this.novaDenuncia_nome.txt;
          this.novaDenuncia_nome.txt = null;
        }
      } else if (this.form.insertField == 'novaDenuncia_empresa') {
        const valid = await this.v$.novaDenuncia_empresa.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaDenuncia_empresa.txt == null) { this.novaDenuncia_empresa.txt = ''; }
          this.form.novaDenuncia.empresa = this.novaDenuncia_empresa.txt;
          this.novaDenuncia_empresa.txt = null;
        }
      } else if (this.form.insertField == 'novaDenuncia_email') {
        const valid = await this.v$.novaDenuncia_email.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaDenuncia_email.txt == null) { this.novaDenuncia_email.txt = ''; }
          this.form.novaDenuncia.email = this.novaDenuncia_email.txt;
          this.novaDenuncia_email.txt = null;
        }
      } else if (this.form.insertField == 'novaDenuncia_setorAreaOutro') {
        const valid = await this.v$.novaDenuncia_setorAreaOutro.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaDenuncia_setorAreaOutro.txt == null) { this.novaDenuncia_setorAreaOutro.txt = ''; }
          this.form.novaDenuncia.setorAreaOutro = this.novaDenuncia_setorAreaOutro.txt;
          this.novaDenuncia_setorAreaOutro.txt = null;
        }
      } else if (this.form.insertField == 'novaDenuncia_denuncia') {
        const valid = await this.v$.novaDenuncia_denuncia.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaDenuncia_denuncia.txt == null) { this.novaDenuncia_denuncia.txt = ''; }
          this.form.novaDenuncia.denuncia = this.novaDenuncia_denuncia.txt;
          this.novaDenuncia_denuncia.txt = null;
        }
      } else if (this.form.insertField == 'novaDenuncia_denunciaMais') {
        const valid = await this.v$.novaDenuncia_denunciaMais.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaDenuncia_denunciaMais.txt == null) { this.novaDenuncia_denunciaMais.txt = ''; }
          this.form.novaDenuncia.denunciaMais = this.novaDenuncia_denunciaMais.txt;
          this.novaDenuncia_denunciaMais.txt = null;
        }
      } else if (this.form.insertField == 'novaDenuncia_emailHistorico') {
        const valid = await this.v$.novaDenuncia_emailHistorico.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaDenuncia_emailHistorico.txt == null) { this.novaDenuncia_emailHistorico.txt = ''; }
          this.form.novaDenuncia.emailHistorico = this.novaDenuncia_emailHistorico.txt;
          this.novaDenuncia_emailHistorico.txt = null;
        }
      } else if (this.form.insertField == 'novaVerificacao_referencia') {
        const valid = await this.v$.novaVerificacao_referencia.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaVerificacao_referencia.txt == null) { this.novaVerificacao_referencia.txt = ''; }
          this.form.novaVerificacao.referencia = this.novaVerificacao_referencia.txt;
          this.novaVerificacao_referencia.txt = null;
        }
      } else if (this.form.insertField == 'novaVerificacao_data') {
        const valid = await this.v$.novaVerificacao_data.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaVerificacao_data.txt == null) { this.novaVerificacao_data.txt = ''; }
          this.form.novaVerificacao.data = this.novaVerificacao_data.txt;
          this.novaVerificacao_data.txt = null;
        }
      } else if (this.form.insertField == 'novaVerificacao_password') {
        const valid = await this.v$.novaVerificacao_password.$validate();
        if (valid) {
          this.form.insert = false;
          this.form.insertField = '';
          if (this.novaVerificacao_password.txt == null) { this.novaVerificacao_password.txt = ''; }
          this.form.novaVerificacao.password = this.novaVerificacao_password.txt;
          this.novaVerificacao_password.txt = null;
        }
      }
    },
    mt_onFileSelect(data) {
      this.novaDenuncia_files.errors = null;
      if (data != null && data.files != null && data.files.length > 0) {
        let error_type = false;
        let error_total = data.files.length;
        let error_size = 0;
        for (let i = 0; i < data.files.length; ++i) {
          if (data.files[i].type != 'image/jpeg' && data.files[i].type != 'application/pdf') { error_type = true; }
          error_size += data.files[i].size;
        }

        if (error_type) {
          this.novaDenuncia_files.errors = this.$store.state.txt_app.field_files_tipo;
        } else if (error_total > 10) {
          this.novaDenuncia_files.errors = this.$store.state.txt_app.field_files_total;
        } else if (error_size / (1024 * 1024) > 20) {
          this.novaDenuncia_files.errors = this.$store.state.txt_app.field_files_size;
        } else {
          this.form.insertField = '';
          if (this.form.novaDenuncia.files == null) { this.form.novaDenuncia.files = []; }
          this.form.novaDenuncia.files.push.apply(this.form.novaDenuncia.files, data.files);
          let files = '';
          for (let i = 0; i < this.form.novaDenuncia.files.length; ++i) {
            files += (i > 0 ? '<br/>' : '') + this.form.novaDenuncia.files[i].name;
          }
          this.novaDenuncia_files.txt = files;
        }
      }
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
